var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Linkedin filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "3ba16b1b-19f9-4fc7-9f15-655bb591486c",
    d: "M14 6.31641C17.314 6.31641 20 9.14379 20 12.6322V20.0007H16V12.6322C16 11.4691 15.105 10.527 14 10.527C12.895 10.527 12 11.4691 12 12.6322V20.0007H8V12.6322C8 9.14379 10.686 6.31641 14 6.31641Z",
    fill: "#1930FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "9dfa1227-af1c-488d-9c39-4189c89a0943",
    y: 7.36719,
    width: 3.99999,
    height: 12.6317,
    fill: "#1930FF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "ce5471cd-63ae-480a-8ca7-0bbfb194ca9a",
    cx: 2,
    cy: 2.10528,
    rx: 2,
    ry: 2.10528,
    fill: "#1930FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIn);
export default __webpack_public_path__ + "static/media/IN.7a01ff462b180b54c585cb4e3967c4ae.svg";
export { ForwardRef as ReactComponent };